import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Modals from 'components/Modals';
import useModalLogic from 'hooks/useModalLogic';
import CreateAccess from 'models/access/createAccess';
import React, { useContext, useState } from 'react';
import { Button } from 'react-bootstrap';
import * as Context from './Context';
import * as Forms from './Forms';

const defaultAccess: CreateAccess = {
  companyName: '',
  password: '',
};

const Create = () => {
  const { createAccess } = useContext(Context.default);
  const [binding, setBinding] = useState<CreateAccess>(defaultAccess);
  const [open, setOpen] = useState(false);

  const submit = async () => createAccess(binding);
  const [handleSubmit, handleClose, error] = useModalLogic<CreateAccess>(
    submit,
    () => setOpen(false),
    () => setBinding(defaultAccess),
  );

  return (
    <>
      <Button title="Opret upload adgang" onClick={() => setOpen(true)}>
        <FontAwesomeIcon icon={faPlus} />
      </Button>
      <Modals.Create
        title="Opret upload adgang"
        onClose={handleClose}
        open={open}
        onSubmit={handleSubmit}
      >
        <Forms.Create value={binding} onChange={setBinding} error={error} />
      </Modals.Create>
    </>
  );
};
export default Create;
